import Datenschutz from './Datenschutz'

export default Datenschutz